(() => {
  // Mobile header: slide the search row away while scrolling down, bring it back on scroll up.
  const header = document.querySelector('.m27-store-header');
  const search = header?.querySelector('.m27-search');
  const brand = header?.querySelector('.m27-wordmark');
  if (!header || !search || !brand) return;

  const topZone = 80;
  const threshold = 6;
  let lastY = window.scrollY;
  let ticking = false;

  // Only collapse when search sits on its own row (the mobile layout), never on desktop.
  const searchOnOwnRow = () => search.offsetTop > brand.offsetTop + brand.offsetHeight / 2;

  const update = () => {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    const delta = y - lastY;
    const keepOpen = y < topZone || search.contains(document.activeElement) || !searchOnOwnRow();
    if (keepOpen) header.classList.remove('is-search-hidden');
    else if (delta > threshold) header.classList.add('is-search-hidden');
    else if (delta < -threshold) header.classList.remove('is-search-hidden');
    if (Math.abs(delta) > threshold || y < topZone) lastY = y;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);
  search.addEventListener('focusin', () => header.classList.remove('is-search-hidden'));
})();
